export function getProcedureAgreedTotal(billingDetails) {
  if (!Array.isArray(billingDetails)) {
    return 0;
  }
  return billingDetails.reduce((sum, item) => {
    const amount = parseFloat(item.agreed_amount);
    return sum + (Number.isNaN(amount) ? 0 : amount);
  }, 0);
}

export function procedureHasPrices(billingDetails) {
  return getProcedureAgreedTotal(billingDetails) > 0;
}

export function formatAgreedAmount(amount) {
  const value = Number(amount) || 0;
  return value.toFixed(2);
}

export function branchFromProcedureLocation(location, admissionBranch) {
  if (admissionBranch) return admissionBranch;
  if (!location) return '';
  const value = String(location).toLowerCase();
  if (value === 'pultney') return 'Pultney';
  if (value === 'kissy') return 'Kissy';
  return location;
}
